export default function () {
  const liveDetails = document.querySelector('.js-event__details__live');
  if (liveDetails) {
    const chronology = getEventLiveChronology(liveDetails);
    const element = document.querySelector(`.js-event__details__live-${chronology}`);
    element?.classList?.remove('is-hidden');
  }

  function getEventLiveChronology(el) {
    const start = el.dataset.start ? Date.parse(el.dataset.start) : 0;
    const end = el.dataset.end ? Date.parse(el.dataset.end) : 0;
    // We assume backend uses Helsinki timezone.
    const current = new Date((new Date()).toLocaleString('en-US', {timeZone:'Europe/Helsinki'})).getTime();

    if (start > current) {
        return 'future';
    } else if (start <= current && (current <= end || !end)) {
        return 'current';
    } else if (end <= current) {
        return 'past';
    } else {
      console.warn('Unhandled time comparison on EventLiveStatus');
    }
  }
}
